import { useNavigate } from 'react-router-dom'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { Pencil } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import type { Process } from 'modules/processes/hooks/useProcesses'

interface Props {
  process: Process
  editPath: string
}

export const ProcessResourceHeader = ({ process, editPath }: Props) => {
  const navigate = useNavigate()

  return (
    <ResourceHeader
      description={process.description || undefined}
      secondaryActions={[
        {
          icon: Pencil,
          label: i18n.t('processes.header.edit'),
          onClick: () => navigate(editPath),
        },
      ]}
      title={process.name}
    />
  )
}
